// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { kava as _kava } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the kava chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 2222
 * Chain Name: Kava EVM
 * Default Block Explorer: https://kavascan.com
 * Default RPC URL: https://evm.kava.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { kava } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: kava,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const kava = createCommon({
	..._kava,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
